export default "__VITE_ASSET__48ce5b54__"